import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { ChartReportRequest, ChartReportResponse, ChartReportStatus } from './chart-report.models';
@Injectable({ providedIn: 'root' })
export class ChartReportApiService {
  async load(endpoint: string, payload: ChartReportRequest): Promise<ChartReportResponse> {
    const response = await axios.post(endpoint, payload);
    const data: unknown = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') {
      const status = data as ChartReportStatus;
      if (status.ISSessionExpired || status.ISessionExpired || status.iResult === 0) return status;
    }
    throw new Error('پاسخ نمودار نامعتبر است');
  }
}
